// Stock is expressed in admissions; selectors sell packs of quantity_factor.
export function ticketStock(ticket) {
  if (!ticket || ticket.sold_out || ticket.is_sold_out || ticket.status === false) return 0
  const limits = [ticket.remaining_tickets, ticket.host_remaining_tickets]
    .filter(value => value !== null && value !== undefined && value !== '')
    .map(Number).filter(Number.isFinite)
  const admissions = limits.length ? Math.max(0, Math.min(...limits)) : Infinity
  const factor = Math.max(1, Number(ticket.quantity_factor ?? ticket.quantity) || 1)
  return Math.floor(admissions / factor)
}

export function ticketAvailability(ticket, now = Date.now()) {
  if (ticketStock(ticket) <= 0) return 0
  if (ticket.expiration_date && new Date(ticket.expiration_date).getTime() <= now) return 0
  if (ticket.sales_date && new Date(ticket.sales_date).getTime() > now) return 2
  return 1
}
